export default __webpack_public_path__ + "static/media/18.c4dcefd5.png";